// extracted by mini-css-extract-plugin
export default {"main":"Sign_main__RWZRb","part1":"Sign_part1__oSyU3"};